import React from 'react'
import ProductDetails from './ProductDetails'
import { useDispatch, useSelector } from 'react-redux'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import { selectNavigation, selectNavigationProduct } from '../actions/digitalMenuActions'

const NavigationProductDetails = (props) => {

  const dispatch = useDispatch()
  const storeCode = useSelector(loadMenuDataSelectors.getStoreCode)
  const navigation = useSelector(loadMenuDataSelectors.getNavigation(props.match.params[1]))
  const product = useSelector(loadMenuDataSelectors.getNavigationProduct(props.match.params[1], props.match.params[2]))
  const nextProduct = useSelector(loadMenuDataSelectors.getNavigationNextProduct(props.match.params[1], props.match.params[2]))
  const previousProduct = useSelector(loadMenuDataSelectors.getNavigationPreviousProduct(props.match.params[1], props.match.params[2]))

  const handleProductClick = (product) => {
    return product != null ? () => {
      dispatch(selectNavigationProduct(navigation, product, storeCode))
    } : null
  }

  const handleNavigationClick = () => {
    dispatch(selectNavigation(navigation, storeCode))
  }

  return <ProductDetails
    product={product}
    handleNextProductClick={handleProductClick(nextProduct)}
    handlePreviousProductClick={handleProductClick(previousProduct)}
    handleBackButtonClick={handleNavigationClick}
    {...props}
  />
}

export default NavigationProductDetails
